export default __webpack_public_path__ + "images/fb256e72a4c92112c26ba9a9fcd8f605-city_browse_top_banner_fallback.webp";